import React, { useState } from 'react';

import { Button, Container } from '@mui/material';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';

import { angularizeWithProviders } from '../../../shared/providers';
import { ModeSelector } from './components/ModeSelector/ModeSelector';
import { GuidedChallengeCreation } from './components/GuidedChallengeCreation/GuidedChallengeCreation';
import { FreeChallengeCreation } from './components/FreeChallengeCreation/FreeChallengeCreation';

import classes from './NgzChallengeCreate.module.scss';
import { CreationMode } from './NgzChallengeCreate.settings';

const NgzChallengeCreate = () => {
  const [creationMode, setCreationMode] = useState<CreationMode | null>(null);

  const renderContent = () => {
    switch (creationMode) {
      case 'GUIDED':
        return <GuidedChallengeCreation />;
      case 'FREEFORM':
        return <FreeChallengeCreation />;
      default:
        return <ModeSelector onNext={setCreationMode} />;
    }
  };

  return (
    <Container>
      <Button
        className={classes.backButton}
        variant="text"
        startIcon={<ArrowBackIosRoundedIcon />}
        color="secondary"
        href="#!/challenges-list"
        size="small"
      >
        Back to Challenge list
      </Button>
      {renderContent()}
    </Container>
  );
};

angularizeWithProviders(NgzChallengeCreate, 'ngzChallengeCreate', {});
